import { Badge, Group, Loader, Text } from '@mantine/core';
import { IconVideo } from '@tabler/icons-react';
import { useMedplum } from '@medplum/react-hooks';
import { useZoomSeatUsage } from '@/hooks/useZoomSeatUsage';
import { zoomSeatUsageSummary } from '@/schemas/zoom.schema';

/** Read-only Zoom seat counts for System Integrations, same source as the old invite warning. */
export function ZoomLicenseStatusCard(): JSX.Element {
  const medplum = useMedplum();
  const { usage, loading, error } = useZoomSeatUsage(medplum, true);

  const detail = loading
    ? 'Loading seat availability…'
    : error
      ? error
      : usage
        ? zoomSeatUsageSummary(usage)
        : 'Seat usage is unavailable.';

  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
      <Group>
        <IconVideo size={24} />
        <div>
          <Text fw={600}>Zoom telehealth licenses</Text>
          <Text size="sm" c="dimmed">
            {detail}
          </Text>
        </div>
      </Group>
      {loading ? (
        <Loader size="sm" />
      ) : usage ? (
        <Badge color={usage.available <= 0 ? 'yellow' : 'gray'} variant="light" size="lg">
          {usage.available} available
        </Badge>
      ) : null}
    </Group>
  );
}
